export default function showReportTab (user, mode, allowRedirects) {
  const userHasReports = user && user.get('features') && user.get('features').reports
  const userHasFolders = user && user.get('folders_enabled') && !allowRedirects
  const inIntegrationMode = mode === 'integration'
  return userHasReports && !userHasFolders && !inIntegrationMode
}
